// extracted by mini-css-extract-plugin
export default {"headerClass":"TableRemote_headerClass__99yLE"};